<template>
  <div>
    <div class="row">
      <div class="col-lg-5">
        <b-form-group>
          <b-input-group size="md">
            <b-form-input
              v-model="pagination.filter"
              :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
              type="search"
              debounce="500"
              @update="searchFilter()"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="!pagination.filter"
                @click="
                  pagination.filter = '';
                  searchFilter();
                "
                >{{ $t("PAGE.DEFAULT.TABLE.CLEAR") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </div>

    <div class="table-content">
      <div class="table-responsive">
        <b-table
          id="referral-table"
          :striped="false"
          :small="true"
          :items="items"
          :fields="fields"
          :busy.sync="isBusy"
          :borderless="false"
          head-variant="light"
        >
          <template #cell(index)="data">
            <div class="text-right">
              {{ (pagination.page - 1) * pagination.perPage + data.index + 1 }}
            </div>
          </template>

          <template #cell(inviter_point)="data">
            <div class="text-right">{{ data.item.inviter_point }}</div>
          </template>

          <template #cell(invitee_point)="data">
            <div class="text-right">{{ data.item.invitee_point }}</div>
          </template>
        </b-table>

        <p class="text-center pt-3" v-if="items.length < 1">
          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
        </p>
      </div>

      <div class="row justify-content-between">
        <div class="col-lg-3">
          <b-form-group
            :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
            label-cols="5"
            label-align-sm="left"
            label-size="lg"
          >
            <b-form-select
              v-model="pagination.perPage"
              size="sm"
              :options="paginationOptions"
              @change="fetchData()"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <b-pagination
            v-model="pagination.page"
            :total-rows="total"
            :per-page="pagination.perPage"
            @input="fetchData()"
            align="right"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "CustomerCampaignReferral",
  props: {
    campaign_id: [String, Number]
  },
  data() {
    return {
      isBusy: false,
      items: [],
      total: 0,
      paginationOptions: [25, 50, 100, 200],
      pagination: {
        page: 1,
        perPage: 25,
        isDesc: true,
        filter: ""
      },
      fields: [
        {
          key: "index",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
          tdClass: "text-right"
        },
        {
          key: "created_at",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.CREATED_AT")}`
        },
        {
          key: "inviter_fullname",
          label: `${this.$t("PAGE.CAMPAIGN_REFERRAL.TABLE.FIELDS.INVITER")}`
        },
        {
          key: "invitee_fullname",
          label: `${this.$t("PAGE.CAMPAIGN_REFERRAL.TABLE.FIELDS.INVITEE")}`
        },
        {
          key: "inviter_point",
          label: `${this.$t("PAGE.CAMPAIGN_REFERRAL.TABLE.FIELDS.INVITER_POINT")}`,
          thClass: "text-right"
        },
        {
          key: "invitee_point",
          label: `${this.$t("PAGE.CAMPAIGN_REFERRAL.TABLE.FIELDS.INVITEE_POINT")}`,
          thClass: "text-right"
        }
      ]
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    searchFilter() {
      this.pagination.page = 1;
      this.fetchData();
    },
    getParams() {
      return {
        page: this.pagination.page,
        perPage: this.pagination.perPage,
        isDesc: this.pagination.isDesc,
        filter: this.pagination.filter,
        campaign_id: this.campaign_id
      };
    },
    fetchData() {
      this.isBusy = true;
      ApiService.setHeader();
      ApiService.getParams("customer_referral/pagination", {
        params: this.getParams()
      })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data.data;
            this.total = data.data.total;
          } else {
            this.items = [];
            this.total = 0;
          }
          this.isBusy = false;
        })
        .catch((error) => {
          this.isBusy = false;
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    }
  }
};
</script>
